import React from "react";
import { ArrowRight } from "lucide-react";

export default function CtaSection() {
  return (
    <section className="tfl-cta" aria-label="Call to action">
      <div className="tfl-cta__inner">
        <h2 className="tfl-cta__h2">
          Ready to scale continuous threat modeling?
        </h2>
        <p className="tfl-cta__body">
          Join security engineers and AppSec teams using ThreatForge to synthesize threat catalogs, simulate attack trees, and automate compliance audits.
        </p>
        <div className="tfl-cta__actions">
          <a href="/signup" className="tfl-btn tfl-btn--primary">
            <span>Get Started Free</span>
            <ArrowRight size={15} />
          </a>
          <a href="/book-demo" className="tfl-btn tfl-btn--ghost">
            <span>Book a Demo</span>
            <ArrowRight size={15} />
          </a>
        </div>
      </div>
    </section>
  );
}
